// src/components/Tutorial/Examples/SupportCard.js
import React from 'react';
import { Card, CardContent, Typography, Box, Button, Stack } from '@mui/material';
import { Support as SupportIcon } from '@mui/icons-material';

export default function SupportCard() {
  return (
    <Box className="example-container" sx={{ mt: 3 }}>
      <Card
        sx={{
          maxWidth: 450,
          mx: 'auto',
          borderRadius: 3,
          boxShadow: 2,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              Need Help?
            </Typography>
            
            <Typography variant="body2" color="text.secondary">
              We're here to help! Use the Contact Support button at the bottom of your dashboard for:
            </Typography>
            
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                background: '#f5f5f5',
                border: '1px dashed #ccc',
              }}
            >
              <Stack spacing={1}>
                <Typography variant="body2" color="text.secondary">
                  • Account verification issues
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  • Subscription syncing problems
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  • Review questions
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  • Payment or billing
                </Typography>
              </Stack>
            </Box>
            
            <Button
              variant="contained"
              fullWidth
              startIcon={<SupportIcon />}
              sx={{
                py: 2,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                fontWeight: 600,
                fontSize: '1rem',
                textTransform: 'none',
                boxShadow: 2,
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                  boxShadow: 4,
                  transform: 'translateY(-2px)',
                },
              }}
            >
              Contact Support
            </Button>
            
            <Typography variant="caption" color="text.secondary" align="center">
              Located at the bottom of your dashboard, full width
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
